import {
  DestinationPlatformMap,
  PlatformVideoType,
} from 'blocks/DestinationPlatforms';
import {
  MixpanelAudiogramDestination,
  MixpanelAudiogramVideoTypes,
} from 'redux/modules/mixpanel/types';

export const DESTINATION_ID_TO_MIXPANEL_DESTINATION_MAP: DestinationPlatformMap<MixpanelAudiogramDestination> = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
  twitter: 'X',
  youtube: 'YouTube',
  threads: 'Threads',
  bluesky: 'Bluesky',
};

export const VIDEO_TYPE_TO_MIXPANEL_VIDEO_TYPE_MAP: Partial<Record<
  PlatformVideoType,
  MixpanelAudiogramVideoTypes
>> = {
  clip: 'EpisodeClip',
  episode: 'FullEpisode',
  post: 'Post',
  reel: 'Reel',
  short: 'Short',
  story: 'Story',
};
